import { render } from "./SelectOMaticTvDisplay.vue?vue&type=template&id=2cce83f4&scoped=true"
import script from "./SelectOMaticTvDisplay.vue?vue&type=script&lang=js"
export * from "./SelectOMaticTvDisplay.vue?vue&type=script&lang=js"

import "./SelectOMaticTvDisplay.vue?vue&type=style&index=0&id=2cce83f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cce83f4"]])

export default __exports__